export type Visibility = 'HIGH' | 'DEFAULT' | 'ALERT' | 'ALERTWHITE' | 'HIGHREVERT' | 'MEDIUM' | 'LOW' | 'LOWREVERT' | 'DISCOVER' | 'DESIGN'
    | 'DEVELOP' | 'DEPLOY' | 'PILOT' | 'SUCCESS' | 'CANCEL';

export function fromVisibility(visibility: Visibility): string {
    switch (visibility) {
        case 'DEFAULT':
            return '_default';
        case 'HIGHREVERT':
            return '_highRevert';
        case 'HIGH':
            return '_high';
        case 'ALERT':
            return '_alert';
        case 'ALERTWHITE':
            return '_alertWhite';
        case 'MEDIUM':
            return '_medium';
        case 'LOWREVERT':
            return '_lowRevert';
        case 'LOW':
            return '_low';
        case 'DISCOVER':
            return '_discover';
        case 'DESIGN':
            return '_design';
        case 'DEVELOP':
            return '_develop';
        case 'DEPLOY':
            return '_deploy';
        case 'PILOT':
            return '_pilot';
        case 'SUCCESS':
            return '_success';
        case 'CANCEL':
            return '_cancel';
    }
}

export type Size = 'LARGE' | 'DEFAULT' | 'SMALL' | 'TINY';


export function fromSize(size: Size): string {
    switch (size) {
        case 'LARGE':
            return '_large';
        case 'DEFAULT':
            return '_default';
        case 'SMALL':
            return '_small';
        case 'TINY':
            return '_tiny';
    }
}

export type Role = 'NEXT' | 'PREVIOUS' | 'DEFAULT';

export function fromRole(role: Role): string {
    switch (role) {
        case 'NEXT':
            return '_next';
        case 'PREVIOUS':
            return '_previous';
        case 'DEFAULT':
            return '';
    }
}
